import * as React from "react";
import pageIds from "~/pageIds";
import type { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import { CommonLibraryGitConnectionOverview, CommonLibraryGitConnectionTopics } from "../../CommonComponents/CommonLibraryGitConnectionViews";
export const LibraryGitConnectionsRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.library.gitConnections.root,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonLibraryGitConnectionOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => {
        return <CommonLibraryGitConnectionTopics />;
    },
};
